module.exports = __webpack_public_path__ + "img/placeholder_img.cef2718b.svg";